import { gsap } from 'gsap';
import { ScrollTrigger } from '../../../node_modules/gsap/dist/ScrollTrigger.js';

class FrontPage {
	selectors = {
		pin: '.pin-wrap',
		panel: '.front-page-feature__section',
		horizontal: '.horizontal-scroller',
		inner: '.front-page-feature__inner',
		wrap: '.section-wrap',
		figureWrap: '.front-page-feature__figure-wrap',
		figure: '.front-page-feature__figure-wrap figure',
		picture: '.front-page-feature__figure-wrap picture',
		content: '.front-page-feature__content',
		pinSpacer: '.pin-spacer',
		sectionItem: '.front-page-feature__section-item',
		effects: {
			pinme: '.pinme',
			shiftleft: '.shiftleft',
			shiftright: '.shiftright',
			fademein: '.fademein',
			shadow: '.shadow',
			scalemeup: '.scalemeup',
			stretch: '.stretch',
			boxes: '.info-box',
			rounded: '.rounded'
		},
		// these attributes will get attention, all data-atts will be run if one of these is present
	};
	animating;
	index = -1;

	timelines = [];

	constructor( node ) {
		this.node = node;

		this.node.querySelectorAll( this.selectors.panel ).forEach( ( panel, index, panels ) => {
			const content = panel.querySelector( this.selectors.content );
			const figure = panel.querySelector( this.selectors.figure );
			const figureWrap = panel.querySelector( this.selectors.figureWrap );
			const inner = panel.querySelector( this.selectors.inner );
			const innerWrap = panel.querySelector( this.selectors.innerWrap );

			if ( figure ) {
				figure.classList.add( 'pinme' );
			}

			// if ( index !== 0 ) {
				if ( content ) {
					content.classList.add( 'pinme' );
				}
			// }

			panel.classList.forEach( className => {
				if ( /^has-.*-(background-color|gradient-background)$/.test( className ) ) {
					if ( figure ) {
						figure.classList.add( className );
					}
					panel.classList.remove( 'has-background', className );
				}
			} );

			if ( index === 0 ) {
				// first section
				panel.classList.add( 'front-page-feature__section--200vw' );

				if ( inner ) {
					inner.classList.add( 'fademein' );
				}
			} else {
				// not first section
				panel.classList.add( 'front-page-feature__section--200vw' );

				if ( figureWrap ) {
					figureWrap.insertAdjacentHTML( 'beforebegin', '<div class="front-page-feature__shadow shiftleft shadow rounded"></div>' );
					figureWrap.classList.add(
						'front-page-feature__figure-wrap--rounded',
						'rounded',
						// 'shiftright',
					);
				}

				if ( innerWrap ) {
					// innerWrap.classList.add( 'shiftleft' );
				}

				if ( inner ) {
					// inner.classList.add( 'shiftright' );
				}

				if ( index === panels.length -1 ) {
					// last section
					if ( inner ) {
						inner.classList.add( 'front-page-feature__inner--50vh' );
					}
				}
			}
		} );

		gsap.registerPlugin( ScrollTrigger );
		this.mm = gsap.matchMedia();

		window.addEventListener( 'resize', () => this.resize() );
		this.resize();
	}

	mediaQueries = {
		desktop: '(min-width: 700px) AND (min-height: 700px)',
		mobile: '(max-width: 699px) OR (max-height: 699px)',
	}

	wasDesktop = null;

	init() {
		this.timelines = Array.from( this.node.querySelectorAll( this.selectors.horizontal ) ).map( scroller => this.timeline( scroller ) );
		this.doTimelines();
	}

	resetNode( node ) {
		gsap.killTweensOf( node );
		node.removeAttribute('style');
	}

	reset() {
		if ( this.timelines.length ) {
			this.timelines.map( timeline => {
				timeline.tween.kill();
				timeline.tween.revert();
			} );

			this.timelines = [];
		}

		for ( let selector in this.selectors ) {
			if ( typeof this.selectors[ selector ] === 'object' ) {
				for ( let prop in this.selectors[ selector ] ) {
					this.node.querySelectorAll( selector[ prop ] ).forEach( node => this.resetNode( node ) );
				}
			} else {
				this.node.querySelectorAll( this.selectors[ selector ] ).forEach( node => this.resetNode( node ) );
			}
		}

		// this removes the pinSpacer wrapper
		this.node.querySelectorAll( this.selectors.pinSpacer ).forEach( node => {
			node.childNodes.forEach( child => node.parentNode.insertBefore( child, node ) );
			node.parentNode.removeChild( node );
		} );
	}

	resize() {
		const isDesktop = window.matchMedia( this.mediaQueries.desktop ).matches;

		if ( ! isDesktop && ( this.wasDesktop || this.wasDesktop === null ) ) {
			this.reset();
		} else if ( isDesktop && ( ! this.wasDesktop || this.wasDesktop === null ) ) {
			this.init();
		}

		this.wasDesktop = isDesktop;
	}

	onDown() {
		!this.animating && this.gotoPanel(this.index - 1, false);
	}

	onUp() {
		!this.animating && this.gotoPanel(this.index + 1, true);
	}

	panelHeightExceedsWindowHeight(index) {
		return this.panels[index] && this.panels[index].offsetHeight > window.innerHeight;
	}

	// handles transitions between horiz/vertical
	gotoPanel(index, isScrollingDown) {

		if (index) {
			if (this.panelHeightExceedsWindowHeight(index)) {
				console.log('!');
			}
		}

		this.animating = true;
		const startORfinish = (index === this.panels.length && isScrollingDown) || (index === -1 && !isScrollingDown);

		// return to normal scroll if we're at the end or back up to the start
		// startORfinish && gsap.to(index, {
		// 	xPercent: isScrollingDown ? -100 : 0,
		// 	duration: 0.00,
		// 	onComplete: () => {
		// 		this.animating = false;
		// 		isScrollingDown && this.observer.disable();
		// 	}
		// });

		this.index = index;
	}

	timeline(scroller) {
		const wrap = scroller.querySelector(this.selectors.wrap);
		this.panels = gsap.utils.toArray(wrap.querySelectorAll(this.selectors.panel));
		gsap.set(this.panels, { zIndex: i => i });

		const timeline = gsap.timeline({
			scrollTrigger: {
				trigger: wrap,
				scrub: true,
				start: 'top top',
				end: () => '+=' + (wrap.scrollWidth - window.innerWidth),
				// invalidateOnRefresh: true,
				pin: true,
				// onEnter: () => {
				// 	this.observer.enable();
				// 	this.gotoPanel(this.index + 1, true);
				// },
				// onEnterBack: () => {
				// 	this.observer.enable();
				// 	this.gotoPanel(this.index - 1, false);
				// }
			},
			defaults: { ease: 'none' }
		});

		return {
			scroller,
			timeline,
			panels: this.panels,
			wrap,
			opts: {
				ease: 'none',
				scrollTrigger: {
					scrub: true,
					invalidateOnRefresh: true,
					start: 'left right',
					end: 'left left',
					toggleActions: "play none none reset",
				},
			},
			tween: timeline.to(this.panels, {
				x: () => (-1 * this.panels.reduce((acc, panel) => { acc += panel.offsetWidth; return acc; }, 0))
			}),
		};
	}

	doTimelines() {
		const { effects, content, inner } = this.selectors;

		this.timelines.forEach(timeline => {
			const { opts, tween, panels, scroller } = timeline;

			this.doOutOfContextAnimations(timeline);

			panels.forEach( ( panel, index ) => {
				this.doPanelAnimations(
					{
						panel,
						opts,
						tween,
						content: panel.querySelectorAll(content),
						inner: panel.querySelectorAll(inner),
						figure: panel.querySelectorAll('figure'),
						picture: panel.querySelectorAll('picture'),
						effects: {
							pinme: panel.querySelectorAll(effects.pinme),
							fademein: panel.querySelectorAll(effects.fademein),
							shadow: panel.querySelectorAll(effects.shadow),
							fademein: panel.querySelectorAll(effects.fademein),
							shiftleft: panel.querySelectorAll(effects.shiftleft),
							shiftright: panel.querySelectorAll(effects.shiftright),
							rounded: panel.querySelectorAll(effects.rounded),
							boxes: panel.querySelectorAll(effects.boxes),
						}
					},
					index
				)
			} );

			scroller.classList.add( `${this.selectors.horizontal.substring( 1 )}--interactive` );
		} );
	}

	// these two tweens are outside of the horizontal context, DO NOT add containerAnimation
	doOutOfContextAnimations(timeline)  {
		const { effects } = this.selectors;
		const { opts } = timeline;

		const toScale = this.panels[0].querySelector(effects.scalemeup);
		const toFadeIn = this.panels[0].querySelector(effects.fademein);
		gsap.set(toFadeIn, { autoAlpha: 0 });
		gsap.set(toScale, { scale: 0.4 });
		gsap.to(toScale,  {
			...opts,
			scale: 1.5,
			scrollTrigger: {
				...opts.scrollTrigger,
				trigger: this.node,
				start: 'top top-=25%',
				end: '+=200vw',
			}})
		gsap.fromTo(toFadeIn,  { autoAlpha: 0 }, {
			...opts,
			autoAlpha: 1,
			scrollTrigger: {
				...opts.scrollTrigger,
				trigger: this.node,
				start: 'top top-=30%',
				end: 'top top-=40%',
			}});
	}

	doPanelAnimations(panel, index) {
		const { opts, effects, tween, content, figure, inner, picture } = panel;

		let { pinme, shiftleft, shiftright, shadow, rounded, boxes } = effects;

		opts.scrollTrigger = {
			...opts.scrollTrigger,
			containerAnimation: tween,
			horizontal: true,
			trigger: panel.panel,
			end: () => `+=${window.innerWidth}vw`,
		}

		// fake pin
		pinme.length && gsap.to(pinme,  {
			...opts,
			x: () => window.innerWidth * 2,
			scrollTrigger: {
				...opts.scrollTrigger,
				start: 'left left',
				// end: () => "+=" + window.innerWidth * ( index === 0 ? 3 : 2 ),
				end: () => "+=" + window.innerWidth * 2,
			}});

		shadow.length && gsap.to(shadow,  { ...opts, autoAlpha: 0.2 });
		shiftleft.length && gsap.to(shiftleft,  { ...opts, x: '-20vw' });
		shiftright.length && gsap.to(shiftright,  { ...opts, x: '20vw' });
		rounded.length && rounded.forEach(el => {
			// gsap.set(el, { ...opts, clipPath: 'ellipse(100% 100% at 100% 50%)' });
			gsap.to(el, {
				...opts,
				clipPath: 'ellipsis(200% 70% at 100% 37%)',
				scrollTrigger: {
					...opts.scrollTrigger,
					trigger: el,
					start: 'left center',
					end: 'left left'
				}
			});
		});

		boxes.length && [...boxes].forEach((box, index) => {
			const styles = getComputedStyle(box);
			gsap.set(box, {
				autoAlpha: 0.1,
				backgroundColor: 'rgba(0,0,0,0)',
				// color: 'rgba(0,0,0,0)',
				x: `${25 * index}vw`
			});
			gsap.to(box, {
				...opts,
				autoAlpha: 1,
				x: 0,
				backgroundColor: styles.getPropertyValue('backgroundColor'),
				scrollTrigger: {
					...opts.scrollTrigger,
					trigger: box,
					start: 'left 90%',
					end: 'left center'
				}
			});
		});

		if(index !== this.panels.length - 1) {
			// content fadeaway
			// be aware:in some cases other elements from inside content or the wrap around use visiblity animations (autoAlpha)
			content.length && gsap.to(content, {
				...opts,
				autoAlpha: 0,
				scrollTrigger: {
					...opts.scrollTrigger,
					trigger: content,
					start: 'right left',
					// this relative value doesn't make sense, but works...
					end: '+=500vw',
				}
			});
		}


		// not first panel
		if(index) {
			inner.length && gsap.set( inner, { x: '20%', autoAlpha: 0 } );
			inner.length && gsap.to( inner, {
				...opts,
				x: 0,
				autoAlpha: 1,
				scrollTrigger: {
					...opts.scrollTrigger,
					start: 'left center',
					end: 'left left-=50%',
				}
			});

			const backgroundColor = getComputedStyle(panel.panel).getPropertyValue('backgroundColor');



			if (figure.length) {
				gsap.set(figure, { scale: 1, filter: 'grayscale(0)' });
				gsap.to(figure, { ...opts, backgroundColor });
				gsap.to(figure, {
					...opts,
					// scale: 1.4,
					duration: 15,
					delay: 2,
					filter: 'grayscale(1)',
					scrollTrigger: {
						...opts.scrollTrigger,
						start: 'left 25%',
						scrub: false,
					}
				});

			}

			picture.length && gsap.set(picture, {
				// scale: 1,
				autoAlpha: 1,
				filter: 'saturate(1)',
			})
			picture.length && gsap.to(picture, {
				filter: 'saturate(0)',
				...opts,
				// scale: 1.2,
				autoAlpha: 0.2,
				scrollTrigger: {
					...opts.scrollTrigger,
					trigger: picture,
					start: 'left center',
					end: 'left left-=100%',
				}
			});

		}
	}
}

let frontPage;

document.addEventListener( 'DOMContentLoaded', () => {
	frontPage = new FrontPage( document.querySelector( '.front-page-feature' ) );
} );

export default frontPage;
